export const convertStrToSlug = (str) => str.toLowerCase().replace(/\s+/g, "-");

export const fetchJSON = async (url) => {
  try {
    const response = await fetch(url);
    if (!response.ok) throw new Error(`Failed to fetch from ${url}`);
    return await response.json();
  } catch (error) {
    console.error(error);
    return null;
  }
};
